import React from "react";
import { Tooltip } from "@paylixecommerce/shared/components";
import { MoreInfo } from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";

const Checkbox = ({ errors, setFieldValue, values, name, note, disabled, onChange, skip, className, label, tooltip }) => {

	let isError = errors[name] && !values[name];

	return <div className={`paylixecommerce-checkbox ${className || ''}`}>
			<input
				type="checkbox"
				id={name}
				name={name}
				disabled={disabled}
				checked={values[name]}
				className={isError && "is-invalid"}
				onChange={(e) => {
					if(onChange) {
						onChange(e)
					}
					if(!skip) {
						setFieldValue(name, e.target.checked)
					}
				}}
			/>

			<label className="paylixecommerce-label" htmlFor={name}>
				{label}
				{tooltip &&
					<span className="ml-1">
						<Tooltip tooltipText={tooltip} name={name} >
							<MoreInfo />
						</Tooltip>
					</span>
				}
				{note && <span className="paylixecommerce-note">{note}</span>}
			</label>
			{isError && <div className="invalid-feedback">{errors[name]}</div>}
		</div>
}

export default Checkbox